import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { BonusType } from "@gql/offer";
import { Fiat, IVSNFeeTokenCollection } from "@models";
import { Tradable } from "@models/interfaces/tradable";
import { SELECTED_CURRENCY } from "@models/trade-offer.model";

export interface IVisionSummaryTotalComponentInput {
	total: number;
	tradable: Tradable;
	fiat: Fiat;
	vsnFeeCollection: IVSNFeeTokenCollection;
}

@Component({
	selector: "vision-summary-total-ui",
	templateUrl: "./vision-summary-total.component.html",
	styleUrl: "./vision-summary-total.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class VisionSummaryTotalComponent {
	vm = input<IVisionSummaryTotalComponentInput>({
		total: 0,
		tradable: null,
		fiat: null,
		vsnFeeCollection: null
	});

	selectedCurrency = input<SELECTED_CURRENCY>(SELECTED_CURRENCY.FIAT);

	bonusType = BonusType;
	selectedCurrencyType = SELECTED_CURRENCY;
}
